export const LOGIN_PATH = "/login";

export const FORGOT_PASSWORD_PATH = "/reset-password";

export const RESET_PASSWORD_PATH = "/reset-password/:passwordResetToken";

export const CANDIDATE_ADD_PROFILE_PATH = "/candidate-add-profile";

export const VERIFY_TOKEN = "/verify-token/:action/:token";

export const CANDIDATE_LOGIN_PATH = "/candidate-login";
export const JOB_EXPIRED = "/job-expired";
export const RECRUITER_LOGIN_PATH = "/recruiter-login";

export const MAINTENANCE_PATH = "/maintenance";

export const LOGIN_PATH_DEV = "/login-dev";
export const CANDIDATE_LOGIN_PATH_DEV = "/candidate-login-dev";
export const RECRUITER_LOGIN_PATH_DEV = "/recruiter-login-dev";
